import React from 'react';
import { Button } from '@/components/ui/button';
import { KeenIcon } from '@/components/keenicons';
import { FormattedMessage } from 'react-intl';

const AgentWelcomeBox = ({ onCreate }) => (
  
  <div className="flex flex-col items-center gap-2">
    <img
      src="/media/images/600x400/add_botchat.png"
      alt="Add Botchat"
      width={80}
      height={80}
      className="mb-10"
    />
    <div className="text-lg font-medium text-gray-800 text-center">
      <FormattedMessage id="AGENTS.HOME.WELCOME" />
    </div>
    <Button className="mt-2 bg-[#00B14F]" onClick={onCreate}>
      <KeenIcon icon="plus" className="me-1" />
      <FormattedMessage id="AGENTS.HOME.CREATE_NEW" />
    </Button>
  </div>
);

export { AgentWelcomeBox }; 